import React, { useState } from 'react';
import { X, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

const DeclineModal = ({ isOpen, onClose, onDecline, caseName }) => {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) {
      return;
    }
    
    setIsSubmitting(true);
    await onDecline(reason);
    setIsSubmitting(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-2xl w-full shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-300">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center">
              <AlertCircle className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Avslå sak</h2>
              <p className="text-sm text-gray-600">{caseName}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <label className="block text-sm font-semibold text-gray-900 mb-2">
            Hvorfor er denne saken irrelevant? *
          </label>
          <p className="text-sm text-gray-600 mb-4">
            Kunden vil motta denne begrunnelsen i en e-post. Vær profesjonell og konstruktiv.
          </p>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Eksempel: Denne saken gjelder et område jeg ikke spesialiserer meg på. Jeg anbefaler at du kontakter en advokat som spesialiserer seg på..."
            className="w-full h-40 border-2 border-gray-300 focus:border-red-400 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-red-200 transition-all resize-none"
            required
          />
          
          <div className="mt-2 text-xs text-gray-500">
            Minimum 50 tegn. Vær profesjonell og hjelpsom.
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 bg-gray-50 rounded-b-2xl">
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1"
          >
            Avbryt
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!reason.trim() || reason.length < 50 || isSubmitting}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white"
          >
            {isSubmitting ? 'Avslår...' : 'Avslå saken'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeclineModal;
